import PageTitle from "../../../Components/UI/PageTitle";
import AddOrEditInstructor from "../../../Components/InstructorsModule/AddOrEditInstructor";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getInstructorDataToUpdate } from "../../../apis";
import Loader from "../../../Components/Loader";
import ErrorAnimationComponent from "../../../assets/lottie/ErrorAnimation/ErrorAnimationComponent";

const UpdateInstructorData = () => {
  const { instructorId } = useParams();
  const [instructorData, setInstructorData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState("");
  console.log(instructorData);

  useEffect(() => {
    setIsLoading(true);

    getInstructorDataToUpdate(instructorId)
      .then((response) => {
        setInstructorData(response.data);
      })
      .catch((error) => {
        setIsError(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [instructorId]);

  if (isLoading) return <Loader />;
  if (isError) return <ErrorAnimationComponent message={isError} />;

  return (
    <>
      <PageTitle
        title={`Update Instructor Data For ${instructorData?.name_en}`}
        BreadcrumbItems={[
          {
            title: "Home",
            link: "/",
          },
          {
            title: "Instructors Management",
            link: "/instructors-management",
          },
          {
            title: "Update Instructor Data",
          },
        ]}
      />
      <AddOrEditInstructor
        mode="edit"
        initialValuesToUpdate={{
          nameEn: instructorData?.name_en || "",
          nameAr: instructorData?.name_ar || "",
          titleEn: instructorData?.title_en || "",
          titleAr: instructorData?.title_ar || "",
          bioEn: instructorData?.bio_en || "",
          bioAr: instructorData?.bio_ar || "",
          email: instructorData?.email || "",
          phone: instructorData?.phone || "",
          mailPartner: instructorData?.contact_email || "",
          phonePartner: instructorData?.whatsapp_number || "",
          isActive: instructorData?.is_active || "1",
          confirm: false,
        }}
        imageToUpdate={instructorData?.image}
      />
    </>
  );
};

export default UpdateInstructorData;
